import React from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';

interface AutomationsFieldContainerProps {
  children: React.ReactNode;
}

export const AutomationsFieldContainer = ({ children }: AutomationsFieldContainerProps): JSX.Element => {
  return (
    <Box className="Automations__FieldContainer" mt={10}>
      {children}
    </Box>
  );
};
